import { FONT_FAMILY, typography } from 'styles/typography'
import colors from 'styles/colors'

const styles = {
  container: {
    fontFamily: FONT_FAMILY,
    marginBottom: 25,
    position: 'relative'
  },
  header: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 25
  },
  headerText: showHeader => {
    return {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      fontSize: 14,
      height: 30,
      opacity: !showHeader && 0
    }
  },
  downLoadButton: {
    color: colors.white,
    backgroundColor: colors.primary,
    textTransform: 'uppercase',
    borderRadius: 25
  },
  printerIcon: {
    transform: 'scaleX(-1)'
  },
  printPage: {
    userSelect: 'none',
    overflowY: 'scroll',
    maxHeight: '70vh',
    marginTop: 45
  },
  printContainer: {
    backgroundColor: '#fff',
    margin: 0,
    padding: '15px 45px'
  },
  printPageCancelButton: {
    borderRadius: 25,
    minWidth: 90,
    backgroundColor: colors.white,
    color: colors.primary,
    border: `1px solid ${colors.primary}`,
    textTransform: 'uppercase',
    marginRight: 15
  },
  printPageCancelPrintButton: {
    borderRadius: 25,
    minWidth: 90,
    color: colors.white,
    backgroundColor: colors.primary,
    textTransform: 'uppercase'
  },
  printPageLogo: {
    pointerEvents: 'none',
    transform: 'scale(1.5)',
    width: 168,
    height: 34,
    marginBottom: 45,
    marginTop: 45,
    marginLeft: 45
  },
  contentArea: {
    position: 'relative',
    minHeight: 450,
    overflowX: 'scroll'
  },
  noDataContainer: {
    container: {
      height: '198px'
    }
  },
  title: {
    fontSize: 24,
    marginBottom: 15,
    flexDirection: 'column',
    justifyContent: 'flex-end',
    color: colors.approxBlack,
    ...typography.fontBold
  },
  context: {
    opacity: 0.6
  },
  disclaimer: {
    border: `1px solid ${colors.lightGray}`,
    margin: '30px 0 15px 0',
    padding: '5px'
  },
  divider: {
    marginTop: 25,
    borderTop: `1px solid ${colors.lightGray}`
  },
  footerBottom: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between'
  },
  headerTitle: showHeader => {
    return {
      textAlign: 'center',
      fontSize: 18,
      marginTop: 15,
      opacity: !showHeader && 0
    }
  },
  space: {
    height: 25
  }
}

export default styles

